// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2boyG","title":"styles_title__1UNkN"};